"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeLanguage = void 0;
var ChangeLanguage_1 = require("./ChangeLanguage");
Object.defineProperty(exports, "ChangeLanguage", { enumerable: true, get: function () { return __importDefault(ChangeLanguage_1).default; } });
